export const VS_IMAGE = Symbol() as InjectionKey<Ref<HTMLImageElement | null>>
